<script setup>
import {computed, onMounted, ref, watch} from "vue";

const props = defineProps({
    content: {
        type: Object,
        required: true,
    }
})

const loaded = ref(false)
const community = ref(null);
const showChannel = ref(false);
const userIsLoggedIn = ref(false);

const loadCommunity = async () => {
    if (!props.content.communityId) {
        loaded.value = true
        return;
    }

    community.value = null

    try {
        const res = await axios.get(route('community.member.getCommunity', props.content.communityId));
        community.value = res.data.community
    } catch (e) {
        loaded.value = true
    }
}

const pageBuilderActive = computed(() => {
    return window.myflow?.pagebuilderActive;
});

const channel = computed(() => {
    if (!community.value || !props.content.channelId) {
        return null;
    }
    return community.value.channels.find(c => c.id === parseInt(props.content.channelId), 10) || null;
});

watch(() => props.content.communityId, (newVal, oldVal) => {
    if(newVal !== oldVal) {
        loadCommunity()
    }
}, {deep: true})

onMounted(() => {
    loadCommunity();

    userIsLoggedIn.value = window.myflow.user.loggedIn;
})

</script>

<template>
    <div>
        <div v-if="userIsLoggedIn">
            <div
                v-if="community && props.content.channel?.id"
                :class="pageBuilderActive ? 'mt-8' : ''"
            >
                <community-channel
                    v-if="channel"
                    :channel-id="props.content.channelId"
                    :channel="channel"
                    :hide-post-feed="true"
                    :hide-channel-meta-text="true"
                    :hide-scoreboard="true"
                    :hide-total-score="! props.content.showScore"
                    :hide-statistics="true"
                    :hide-tab-bar="true"
                    :hide-track-record="true"
                    :submit-post-button-label="props.content.postButtonLabel"
                    :show-add-post-text-button="props.content.showAddTextButton"
                    :show-set-post-date-button="props.content.showDateSelector"
                    :show-background="false"
                ></community-channel>

                <div
                    v-if="props.content.showOpenChannelButton"
                    class="flex justify-center mt-2"
                >
                    <button-secondary
                        size="sm"
                        @click="showChannel = true"
                    >{{ _mft('community:channel.progressTracking.checkIn.openChannel') }}</button-secondary>
                </div>

                <slideout-with-slots
                    max-width-class="max-w-[80vw] md:max-w-screen"
                    v-if="showChannel"
                    @close="showChannel = false"
                >
                    <template #title>
                        <h2>{{ props.content.channel.name }}</h2>
                    </template>
                    <template #body>
                        <community-channel
                            :channel-id="props.content.channel.id"
                            :channel="props.content.channel"
                        ></community-channel>
                    </template>
                </slideout-with-slots>
            </div>

            <div
                v-if="! loaded && ! community"
                class="flex justify-center py-12"
            >
                <mf-spinner-medium class="w-24 h-12"/>
            </div>

            <p
                v-if="loaded && ! community"
                class="text-center py-12"
            >
                {{ _mft('community:communities.notMemberOfThisCommunity') }}
            </p>
        </div>
    </div>
</template>

<style scoped>

</style>
